// extracted by mini-css-extract-plugin
export default {"alum":"alum_alum__j86mt","skipLink":"alum_skipLink__5bfZY","containerAlum":"alum_containerAlum__uYml9","headings":"alum_headings__dTd2O"};